import {
  TextControl,
  SelectControl,
  Button,
  TextareaControl,
  Spinner,
} from "@wordpress/components";
import { useState, useRef, useEffect } from "@wordpress/element";
import envelope from "../../images/susana-schmitz-fotografia-quote-envelope.svg";
import apiFetch from "@wordpress/api-fetch";

const FloatingButton = () => {
  const [openModal, setOpenModal] = useState(false);

  const [name, setName] = useState("Marcel");
  const [email, setEmail] = useState("marcel@pluginslab.com");
  const [phoneNumber, setPhoneNumber] = useState("938936330");
  const [sessionType, setSessionType] = useState("maternidade");
  const [message, setMessage] = useState("Isto é uma mensagem");

  const [isSending, setIsSending] = useState(false);
  const [isError, setIsError] = useState(false);
  const [sent, setSent] = useState(false);

  const [errorName, setErrorName] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPhoneNumber, setErrorPhoneNumber] = useState(false);

  const sessionTypes = [
    { value: "maternidade", label: "Sessão de Maternidade" },
    { value: "recém-nascido", label: "Sessão de Recém-Nascido" },
    { value: "bebe-crianca", label: "Sessão Bebé-Criança" },
    { value: "familia", label: "Sessão de Família" },
    { value: "aniversario", label: "Sessão de Aniversário / Smash the Cake" },
  ];

  const modalRef = useRef(null);

  const processForm = () => {
    return () => {
      if (!name) {
        setErrorName(true);
      } else {
        setErrorName(false);
      }

      if (!email || !email.includes("@")) {
        setErrorEmail(true);
      } else {
        setErrorEmail(false);
      }

      if (!phoneNumber || phoneNumber.length < 9) {
        setErrorPhoneNumber(true);
      } else {
        setErrorPhoneNumber(false);
      }

      if (name && email && phoneNumber && sessionType) {
        postQuoteRequest();
      }
    };
  };

  const postQuoteRequest = () => {
    const data = {
      title: name,
      content: `
                <!-- wp:paragraph -->
                <p><strong>Email:</strong> ${email}</p>
                <!-- /wp:paragraph -->
        
                <!-- wp:paragraph -->
                <p><strong>Telefone:</strong> ${phoneNumber}</p>
                <!-- /wp:paragraph -->
        
                <!-- wp:paragraph -->
                <p><strong>Tipo de Sessão:</strong> ${sessionType}</p>
                <!-- /wp:paragraph -->
        
                <!-- wp:paragraph -->
                <p><strong>Mensagem:</strong> ${message}</p>
                <!-- /wp:paragraph -->
            `,
      meta: {
        ms_quote_phone: phoneNumber,
        ms_quote_email: email,
        ms_quote_type: sessionType,
        ms_quote_sent: false,
      },
    };

    setIsSending(true);

    apiFetch({
      path: "/wp/v2/ms-cpt-quote",
      method: "POST",
      data: data,
    })
      .then((response) => {
        setIsSending(false);
        setErrorName(false);
        setErrorEmail(false);
        setErrorPhoneNumber(false);
        setSent(true);
        apiFetch({
          path: "/ms-susy-helper/v1/send-email?quote_id=" + response.id,
          method: "GET",
        })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
        setIsSending(false);
        setIsError(true);
        setSent(false);
      });
  };

  useEffect(() => {
    const floatingButton = document.querySelector(".floating-button button");
    const modal = document.querySelector(".modal");

    floatingButton.addEventListener("click", () => {
      setOpenModal(true);
    });

    window.addEventListener("click", (event) => {
      if (event.target === modal) {
        setOpenModal(false);
      }
    });

    modalRef.current = document.querySelector(".modal");
  }, []);

  useEffect(() => {
    const modal = modalRef.current;
    if (openModal) {
      modal.style.display = "flex";
      if (sent) {
        setSent(false);
        setName("");
        setEmail("");
        setPhoneNumber("");
        setSessionType("");
        setMessage("");
      }
    } else {
      modal.style.display = "none";
    }
  }, [openModal]);

  return (
    <>
      <div className="modal">
        <div className="modal-content">
          <span className="close" onClick={() => setOpenModal(false)}>
            &times;
          </span>
          <figure className="wp-block-image aligncenter envelope">
            <img src={envelope} alt="Pedido de Orçamento Enviado." />
          </figure>

          <h2>Pedido de Orçamento</h2>
          <div className="form">
            {sent && (
              <>
                <p>&nbsp;</p>
                <p>
                  <strong>
                    Muito obrigada, o seu pedido foi recebido com sucesso.
                    Acabámos de enviar um email com todos os detalhes.
                  </strong>
                </p>
                <p>
                  Por favor consulte a sua caixa de correio eletrónica, nela
                  encontrará todos os detalhes para o tipo de sessão de pediu.
                  Se entretanto tiver alguma dúvida por favor não hesite em{" "}
                  <a href="/contacto" target="_blank">
                    contactar-me
                  </a>
                  .
                </p>
                <p>
                  Até breve,
                  <br />
                  <span className="signature">Susana Schmitz</span>
                </p>
              </>
            )}
            {!sent && (
              <>
                <p>
                  Preencha o seguinte formulário para um pedido de orçamento
                  para a sessão que pretende fazer.
                </p>
                <TextControl
                  label="Primeiro e Último nomes *"
                  value={name}
                  onChange={(value) => {
                    setName(value);
                  }}
                  help={errorName ? "Este campo é obrigatório." : ""}
                />
                <TextControl
                  label="Email *"
                  value={email}
                  help={
                    errorEmail
                      ? "Por favor preenchar um endereço de email válido."
                      : ""
                  }
                  onChange={(value) => {
                    setEmail(value);
                  }}
                />
                <TextControl
                  label="Número de Telefone *"
                  value={phoneNumber}
                  help={
                    errorPhoneNumber
                      ? "Por favor preencha um número de telefone válido."
                      : ""
                  }
                  onChange={(value) => {
                    setPhoneNumber(value);
                  }}
                />
                <SelectControl
                  label="Tipo de Sessão *"
                  value={sessionType}
                  options={sessionTypes}
                  onChange={(value) => {
                    setSessionType(value);
                  }}
                />
                <TextareaControl
                  label="Deixe a sua mensagem"
                  value={message}
                  onChange={(value) => {
                    setMessage(value);
                  }}
                />
                {isSending ? (
                  <Spinner />
                ) : (
                  <Button onClick={processForm()}>Enviar Pedido</Button>
                )}
                <p class="text-small">
                  Todos os dados recolhidos são tratados de conforme a lei de
                  proteção de dados.
                </p>
                {isError && (
                  <p class="text-small text-danger">
                    Ocorreu um erro ao enviar o seu pedido. Por favor tente
                    novamente.
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="floating-button">
        <button>Pedido de Orçamento</button>
      </div>
    </>
  );
};

export default FloatingButton;
